import { AlertTriangle } from "lucide-react";
import { fmt } from "@/lib/dates";

export const ClashWarning = ({ clashes, testid = "holiday-clash-warning" }) =>
  clashes?.length ? (
    <div className="rounded-xl border border-amber-300 bg-amber-50 px-3 py-2.5 text-sm text-amber-900" data-testid={testid}>
      <div className="flex items-center gap-2 font-bold"><AlertTriangle className="w-4 h-4" /> Clashes with approved team leave</div>
      <ul className="mt-1 pl-6 list-disc">
        {clashes.map((c) => (
          <li key={c.id}>{c.user_name}: {fmt(c.start_date, "d MMM")} – {fmt(c.end_date, "d MMM")}</li>
        ))}
      </ul>
    </div>
  ) : null;
